import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { renderRoutes } from 'react-router-config'

import { MyProfile } from 'containers/misc'
import {
  HeaderDashboard,
  AwardSubHeader,
  DashboardGrid as Grid,
  BurgerMenu
} from 'components/layout'
import {
  ActivitiesList,
  FinishAward,
  StartNewAward,
  AwardToasts
} from 'components/sections/dashboard'
import {
  ChangeMajorActivityModal,
  RegistrationInfoModals,
  NewBadgeModal
} from 'components/modals'
import { apiConfiguration, apiDashboard, apiLocales } from 'helpers/decorators/api'
import { meta } from 'helpers/decorators'
import { AWARD_LEVELS, AWARD_STATES, CONFIGURATION_KEYS } from 'constants/enums'
import MODALS from 'constants/layout/modals'
import canHaveMajor from 'helpers/dashboard/canHaveMajor'
import mustBeMajor from 'helpers/dashboard/mustBeMajor'
import getAJProgressArray from 'helpers/dashboard/getAJProgressArray'
import config from 'config'
import { setAwardCustomizationLoading, setCurrentAward } from '../../../redux/modules/api/awards'

const notApprovedStates = [
  AWARD_STATES.reg_assignment.id,
  AWARD_STATES.reg_approval.id,
  AWARD_STATES.reg_not_approved.id,
  AWARD_STATES.inactive.id
]

@meta({ title: 'Dashboard', intlKey: 'route.dashboard' })
@apiDashboard.apiPersons({
  loadProfile: true
})
@apiDashboard.apiAwards({
  fetchAward: true,
  loadAward: true,
  checkParentalConsent: true,
  checkIfPaid: true
})
@apiLocales()
@apiDashboard.apiAdventurousJourney({ loadCategories: true })
@apiConfiguration({ getValue: CONFIGURATION_KEYS.isPersonalReflectionMandatory.id })
@connect(({ app, api }) => ({
  modalData: app.modal.data,
  regLocales: api.locales.registration.data,
  activeModal: app.modal.id,
  awardCustomization: api.awards.customization
}))
class Dashboard extends Component {
  static propTypes = {
    activeModal: PropTypes.string,
    location: PropTypes.object,
    regLocales: PropTypes.array,
    route: PropTypes.object,
    awards: PropTypes.object,
    currentAward: PropTypes.object,
    modalData: PropTypes.object,
    aJValues: PropTypes.object,
    notifyBlockedAward: PropTypes.func,
    configuration: PropTypes.object,
    loadRegistrationLocales: PropTypes.func.isRequired,
    onGetConfigurationValue: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    awardCustomization: PropTypes.object
  }

  componentDidUpdate = nextProps => {
    const { currentAward } = this.props

    if (currentAward !== nextProps.currentAward) {
      const naoId = get(currentAward, 'organization.parentNAO.id')

      naoId && this.props.loadRegistrationLocales(naoId)
      this.loadAwardCustomization(naoId, currentAward)
    }
  }

  async loadAwardCustomization(naoId, currentAward) {
    if (naoId) {
      const currentLevel = get(currentAward, 'awardLevel.value')

      await this.props.dispatch(setAwardCustomizationLoading(true))
      try {
        await this.props.dispatch(setCurrentAward(currentAward))

        switch (currentLevel) {
          case AWARD_LEVELS.bronze.id:
            await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.awardBronzeMedalImage.id, naoId)
            break

          case AWARD_LEVELS.silver.id:
            await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.awardSilverMedalImage.id, naoId)
            break

          case AWARD_LEVELS.gold.id:
            await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.awardGoldMedalImage.id, naoId)
            break

          default:
        }
      }
      finally {
        await this.props.dispatch(setAwardCustomizationLoading(false))
      }
    }
  }


  render() {
    const {
      location,
      route,
      awards,
      params,
      modalData,
      aJValues,
      currentAward,
      notifyBlockedAward,
      configuration,
      regLocales,
      awardCustomization
    } = this.props

    const indexRoute = `${config.publicPath}/dashboard/awards/${params.awardId}`

    const awardState = get(awards, 'data.awardState.value')

    const isPersonalReflectionMandatoryCfg = get(configuration, `values[${CONFIGURATION_KEYS.isPersonalReflectionMandatory.id}]`)

    const isPersonalReflectionMandatory = isPersonalReflectionMandatoryCfg && get(isPersonalReflectionMandatoryCfg, 'booleanValue')

    const isRegLocalesEnabled = regLocales && regLocales.length > 0

    const bronzeMedalUrl = get(configuration, `values[${CONFIGURATION_KEYS.awardBronzeMedalImage.id}].textValue`)

    const silverMedalUrl = get(configuration, `values[${CONFIGURATION_KEYS.awardSilverMedalImage.id}].textValue`)

    const goldMedalUrl = get(configuration, `values[${CONFIGURATION_KEYS.awardGoldMedalImage.id}].textValue`)

    const showMedal = awardCustomization.loaded ? true : 'blank'

    return (
      <div>
        <BurgerMenu
          indexRoute={indexRoute}
          awards={get(awards, 'data')}
          routeParams={params}
        />

        <HeaderDashboard awards={get(awards, 'data')} indexRoute={indexRoute} />

        <Grid.Wrap>
          {/* if location is index route, it means that we want to see the Activity list. */}
          <Grid.Left isSmDetail={get(location, 'pathname') !== indexRoute}>
            <AwardSubHeader
              title={get(awards, 'data.awardLevel.translationText')}
              subtitle={get(awards, 'data.completionText')}
              awardLevel={get(awards, 'data.awardLevel')}
              awardId={Number(get(params, 'awardId'))}
              awards={awards}
              medal={showMedal}
              bronzeMedalUrl={bronzeMedalUrl}
              silverMedalUrl={silverMedalUrl}
              goldMedalUrl={goldMedalUrl}
              hills
            />

            <ActivitiesList
              aJValues={aJValues}
              awardType={get(awards, 'data.awardType')}
              awardLevel={get(awards, 'data.awardLevel')}
              awardStartDate={get(awards, 'data.startDate')}
              residentialProject={get(awards, 'data.residentialProject')}
              canSetupSections={get(awards, 'data.canSetupSections')}
              activities={get(awards, 'activities')}
              awardId={Number(get(params, 'awardId'))}
              ajProgress={getAJProgressArray(get(awards, 'data.ajProgress'))}
              showMajor={canHaveMajor(awards)}
              mustBeMajor={mustBeMajor(
                awards,
                get(modalData, 'activity.activitySection.value')
              )}
              loading={get(awards, 'loading')}
              loaded={get(awards, 'loaded')}
              isBlocked={get(currentAward, 'isBlocked')}
              notifyBlockedAward={notifyBlockedAward}
            />
          </Grid.Left>

          <Grid.Right
            notApproved={notApprovedStates.includes(awardState)}
            isFetchingAward={get(awards, 'loading', false)}
          >
            {route && renderRoutes(route.routes, {
              awards
            })}
          </Grid.Right>
        </Grid.Wrap>

        <MyProfile isRegLocalesEnabled={isRegLocalesEnabled} />

        <ChangeMajorActivityModal
          activities={get(awards, 'data.activities')}
          modalId={MODALS.CHANGE_MAJOR_ACTIVITY}
          params={params}
        />

        {this.props.activeModal === MODALS.NEW_BADGE_ACHIEVED && (<NewBadgeModal data={modalData} modalId={MODALS.NEW_BADGE_ACHIEVED} />)}

        {this.props.activeModal === MODALS.REGISTRATION_INFO && (
          <RegistrationInfoModals
            awardId={params.awardId}
            modalId={MODALS.REGISTRATION_INFO}
            orgId={currentAward.organization.id}
          />
        )}

        <AwardToasts awardState={get(awards, 'data.awardState')} />

        <FinishAward
          canBeSentForSignoff={get(awards, 'data.canBeSentForSignoff')}
          awardId={Number(get(params, 'awardId'))}
          isPersonalReflectionMandatory={isPersonalReflectionMandatory}
        />

        <StartNewAward
          isCompleted={get(awards, 'data.isCompleted')}
          showNewLevelMessage={get(awards, 'data.showNewLevelMessage')}
          awardId={Number(get(params, 'awardId'))}
          awardLevelText={get(awards, 'data.awardLevel.translationText')}
        />
      </div>
    )
  }
}

export default Dashboard
